import { memo } from 'react';
import { CellAvatar } from '@odo/shared-ui';
import { PaneCloseButton } from '../PaneCloseButton';
import { identitySubline, type PaneIdentity } from './paneIdentity';

interface IdentityBarProps {
    identity: PaneIdentity;
    today: string;
}

function IdentityBarContent({ identity, today }: IdentityBarProps) {
    const subline = identitySubline(identity, today);
    return (
        <div className="flex h-[68px] shrink-0 items-center gap-3 bg-white pl-5 pr-4">
            <CellAvatar
                name={identity.name}
                className="h-10 w-10"
                initialsClassName="text-[14px]"
            />
            <div className="flex min-w-0 flex-1 flex-col">
                <h3 className="truncate text-[16px] font-semibold leading-5 text-gray-900">
                    {identity.name}
                </h3>
                {subline && (
                    <p className="truncate text-[12px] leading-4 text-gray-500">{subline}</p>
                )}
            </div>
            <PaneCloseButton />
        </div>
    );
}

const sameIdentity = (prev: IdentityBarProps, next: IdentityBarProps) =>
    prev.today === next.today &&
    prev.identity.name === next.identity.name &&
    prev.identity.chartNumber === next.identity.chartNumber &&
    prev.identity.dateOfBirth === next.identity.dateOfBirth &&
    prev.identity.gender === next.identity.gender;

export const IdentityBar = memo(IdentityBarContent, sameIdentity);
